import { ParcellingType } from "../types";

export const PARCELLING_TYPE_OPTIONS: { value: ParcellingType; label: string }[] = [
    { value: 'fixed', label: 'Fixo' },
    { value: 'dynamic', label: 'Dinâmico' },
];